import { Route, Switch } from '@treams/treams-routes';

import Conversation from './Conversation';
import ConversationsModals from './ConversationsModals';
import ViewerIncomingConversations from './ViewerIncomingConversations';
import ViewerOutgoingConversations from './ViewerOutgoingConversations';
import UserIncomingConversations from './UserIncomingConversations';
import UserOutgoingConversations from './UserOutgoingConversations';

export default function Conversations() {
	return (
		<Switch>
			<Route
				exact
				path={[
					'/users/:userID/conversations/create',
					'/users/:userID/conversations/create-from-moment/:momentID',
					'/users/:userID/conversations/request',
					'/users/:userID/conversations/request-from-moment',
					'/users/:userID/conversations/request-from-moment/:momentID',
					'/users/:userID/conversations/outgoing',
					'/users/:userID/conversations',
					'/conversations/outgoing',
					'/conversations',
					'/conversations/request-from-moment',
					'/conversations/request-from-moment/:momentID',
					'/conversations/request',
					'/conversations/create',
				]}
			>
				<Switch>
					<Route exact path="/conversations/outgoing">
						<ViewerOutgoingConversations />
					</Route>
					<Route path="/conversations">
						<ViewerIncomingConversations />
					</Route>
					<Route exact path="/users/:id/conversations/outgoing">
						<UserOutgoingConversations />
					</Route>
					<Route path="/users/:id/conversations">
						<UserIncomingConversations />
					</Route>
				</Switch>
				<ConversationsModals />
			</Route>
			<Route<{ userID?: string; conversationID: string }>
				path={[
					'/conversations/:conversationID',
					'/users/:userID/conversations/:conversationID',
					'/conversations/:conversationID/change-date',
					'/users/:userID/conversations/:conversationID/change-date',
				]}
				exact
			>
				{({ match }) => (
					<Conversation
						userID={match!.params.userID}
						conversationID={match!.params.conversationID!}
					/>
				)}
			</Route>
		</Switch>
	);
}
